<template>
  <div class="questions-form">
    <ValidationObserver
      class="questions-form__wrapper"
      v-if="!questionsAreAnswered"
      ref="observer"
    >
      <div class="questions-back-button" @click="handleBackward">
        <svg width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.85706 8.04029L0.0878906 4.27112L3.85706 0.501953L4.55956 1.20445L1.49289 4.27112L4.55956 7.33779L3.85706 8.04029Z" fill="#A9A9A9"/>
        </svg>
        Voltar
      </div>

      <div class="questions-vacancy-name">{{ vacancy.name }}</div>
      <form @submit.prevent="onSubmit">
        <div
          class="questions-form__content"
          v-for="form in forms"
          :key="form._id"
        >
          <h1 class="questions-form__title">{{form.name}}</h1>
          <p class="questions-form__description">
            É necessário responder estas perguntas para confirmar sua candidatura.
          </p>
          <div
            class="question-form__group-inputs"
            v-for="question in form.questions"
            :key="question._id"
          >
            <question-text
              :answer="answers[question._id]"
              :question="question"
            />

            <question-text-area
              :answer="answers[question._id]"
              :question="question"
            />
          </div>
        </div>
      </form>
      <div class="questions-form__group-buttons">
        <button 
          @click="handleForward" 
          class="questions-form__foward-button"
        >
          Confirmar Candidatura
        </button>
      </div>
    </ValidationObserver>
    <div v-else class="thankyou-wrapper">
      <img
        class="empty-detail__image"
        src="@/assets/images/thank_you.png"
        alt="Imagem de agradecimento"
        width="300"
      />
      <p>
        Obrigado por responder o nosso questionário, sua participação é muito
        importante. Nossos recrutadores irão avaliar as respostas enviadas.
      </p>
      <div class="questions-form__group-buttons">
        <vs-button type="border" @click="handleBackward">Voltar</vs-button>
        <vs-button @click="handleForward">Continuar</vs-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.questions-form {
  font-family: 'Roboto', sans-serif;
  width: 95%;
  height: calc(100vh - 75px);
  padding: 10px;
  margin: 0 auto;
  background-color: #fff;

  display: flex;
  flex-direction: column;

  h4 {
    color: #fff;
  }

  form {
    margin: 0 auto;
    flex: 1;
  }
}

.questions-form__wrapper {
  max-width: 415px;
  margin: 0 auto;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.questions-back-button {
  color: #696969;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
}

.questions-vacancy-name {
  color: #696969;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  margin-bottom: 4px;
}

.questions-form__content {
  display: flex;
  flex-direction: column;
}

.questions-form__title {
  font-size: 22px;
  font-weight: 600;
  line-height: 25.78px;
  color: #333333;
  margin-bottom:8px;
}

.questions-form__description {
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  color: #4F4F4F;
}

.question-form__group-inputs {
  margin-top: 20px;
}

.questions-form__group-buttons {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  margin: 20px 0;
}
.questions-form__foward-button {
  width: 100%;
  height: 48px;
  padding: 8px 16px 8px 16px;
  gap: 10px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 18.75px;
  color: #fff;
  border: 0;
  cursor: pointer;
  background-color: #4169E1;

  &:hover {
    background-color: darken(#4169E1, 15%);
  }
}
</style>

<script>
import { ValidationObserver } from "vee-validate";
import QuestionText from "./QuestionText.vue";
import QuestionTextArea from "./QuestionTextArea.vue";

import ForwardButton from "@/components/ForwardButton";
import BackwardButton from "@/components/BackwardButton";
import { mapState } from "vuex/dist/vuex.common.js";

export default {
  components: {
    ValidationObserver,
    QuestionText,
    QuestionTextArea,
    ForwardButton,
    BackwardButton
  },
  name: "questions-form",
  props: {
    forms: {
      type: Array,
      required: true
    },
    answered: {
      type: Array,
      required: true
    },
    answers: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapState("vacancy", ["vacancy"]),
  },
  data: () => ({
    application_id: undefined,
    policiedAndTermsError: true,
    questionsAreAnswered: false
  }),
  methods: {
    handleBackward() {
      const { params } = this.$router.history.current;

      this.$router.push({
        name: "step-revision",
        params
      });
    },

    handleForward() {
      this.onSubmit();
    },

    async onSubmit() {
      try {
        const isValid = await this.$refs.observer.validate();

        if (!isValid) return;

        this.$vs.loading({ text: "enviando respostas" });

        const { vacancy_id } = this.$router.history.current.params;

        let answers = Object
          .keys(this.answers)
          .map(key => ({
            question_id: key,
            value: this.answers[key].value === ""
              ? null
              : this.answers[key].value
            }));

        answers = [...answers, ...this.answered];
        
        await this.$http.post(
          `/api/v1/questions/steps/vacancies/${vacancy_id}`,
          {
            form_id: this.forms[0]._id,
            application_id: this.application_id,
            answers
          }
        );  

        this.$vs.loading.close();

        const { params } = this.$router.history.current;
        this.$router.push({
          name: "dashboard-vacancy",
          params,
          query: {
            success: true,
          }
        });

        this.$router.push();
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    async fetchTalentApplicationID() {
      try {
        const { vacancy_id } = this.$router.history.current.params;

        const response = await this.$http.get(
          `/api/v2/talents/application?vacancy_id=${vacancy_id}`
        );

        this.application_id = response.data.ap;
      } catch (error) {
        //
      }
    }
  },
  created() {
    this.fetchTalentApplicationID();
  }
};
</script>
